export default __webpack_public_path__ + "static/media/Animals_02.c14061d3.png";